import { Controller } from '@hotwired/stimulus'

// Jumps between incomplete required fields in a SuperForm.
// Receives the list of slugs from the server on every nav morph.
export default class extends Controller {
  static values = { incompleteIds: Array }

  connect() {
    this.currentIndex = -1
  }

  incompleteIdsValueChanged() {
    this.currentIndex = -1
  }

  next() {
    if (this.incompleteIdsValue.length === 0) return

    this.currentIndex = (this.currentIndex + 1) % this.incompleteIdsValue.length
    this.navigate()
  }

  previous() {
    if (this.incompleteIdsValue.length === 0) return

    this.currentIndex =
      this.currentIndex <= 0 ? this.incompleteIdsValue.length - 1 : this.currentIndex - 1
    this.navigate()
  }

  navigate() {
    const id = this.incompleteIdsValue[this.currentIndex]
    const target = document.getElementById(id)
    if (!target) return

    target.scrollIntoView({ behavior: 'smooth', block: 'center' })

    const input = target.querySelector('input:not([type=hidden]), select, textarea')
    if (input) input.focus({ preventScroll: true })
  }
}
